import React, { useState } from "react";
import OtpInput from "react-otp-input";
import {
    Dialog,
    DialogContent,
    IconButton,
    Box,
    Typography,
    useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Mail from "../assets/logo/mail.svg";

export default function AppOtpScreen({ show, validateOtp, onClose, email }) {
    const [otp, setOtp] = useState("");
    const isMobile = useMediaQuery("(max-width:600px)");
    const [errorMessage, setErrorMessage] = useState("");

    const handleClose = () => {
        console.error("User Canceled the operation");
        setErrorMessage(false);
        setOtp("")
        if (onClose) onClose(false);
    };

    const handleOtpChange = async (value) => {
        setErrorMessage("");
        setOtp(value);
        if (value.length === 6) {
            const res = await validateOtp(value);
            if(res.error) {
                setErrorMessage(res?.error?.response?.data?.message || res?.error?.message)
            }
        }
    };

    return (
        <Dialog open={show} fullScreen={isMobile} maxWidth="xs" fullWidth PaperProps={{
            sx: {
                borderRadius: isMobile ? 0 : 8
            }
        }}>
            <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: isMobile ? "100vh" : "auto", paddingTop: 5, paddingBottom: 5, paddingRight: 0, paddingLeft: 0}}>
                <IconButton sx={{ position: "absolute", top: 10, right: 10 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <Mail style={{ width: 50, height: 50, color: '#6851ff'}}></Mail>
                <Typography variant="h6" marginTop={3} marginBottom={3} color={"#000"} textAlign={'center'}>Please enter the code sent to <b>{email}</b></Typography>
                <OtpInput
                    value={otp}
                    onChange={handleOtpChange}
                    numInputs={6}
                    renderInput={(props) => <input {...props} />}
                    inputStyle={{
                        width: "2.0rem",
                        height: "2.0rem",
                        padding: 5,
                        margin: "0.5rem",
                        fontSize: "1.5rem",
                        textAlign: "center",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                      }}
                />
                <Box marginBottom={4} paddingTop={1}>
                    <Typography color={'#FF9494'} fontSize={18}>{errorMessage}</Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
